import { useEffect } from 'react'
import { useSearchParams } from 'react-router'
import isEmpty from 'lodash-es/isEmpty'

import {
  SUBMENU_OUTBOUND_COMPANY_PARAM_KEY,
  SUBMENU_PARAM_ACTIVE_VALUE,
  SUBMENU_PARAM_KEY,
} from '../../../../constants/route'
import { ITEM_KEYS } from '../IdwellToIdwellSubMenu.constants'
import { getSubMenuIdwellToIdwellDefaultValue } from '../IdwellToIdwellSubMenu.utils'

export function useDefaultIdwellToIdwellParams({ outboundCompanies }) {
  const [searchParams, setSearchParams] = useSearchParams()

  const outboundCompanyUuid = searchParams.get(
    SUBMENU_OUTBOUND_COMPANY_PARAM_KEY
  )

  useEffect(() => {
    if (!outboundCompanyUuid && !isEmpty(outboundCompanies)) {
      const params = {
        [SUBMENU_OUTBOUND_COMPANY_PARAM_KEY]:
          getSubMenuIdwellToIdwellDefaultValue(outboundCompanies)[
            ITEM_KEYS.selectedKey
          ],
        [SUBMENU_PARAM_KEY]:
          searchParams.get(SUBMENU_PARAM_KEY) || SUBMENU_PARAM_ACTIVE_VALUE,
      }

      setSearchParams(params)
    }
  }, [outboundCompanies, outboundCompanyUuid])
}
